import { iconFactory } from '../iconFactory'

export interface ArrowDoubleProps {
  fill?: string
  direction?: 'right' | 'left'
}

export const ArrowDouble = iconFactory(
  'ArrowDouble',
  ({ fill, direction = 'right' }: ArrowDoubleProps) => {
    switch (direction) {
      case 'left':
        return (
          <>
            <path
              d="M16.59 18L18 16.59L13.42 12L18 7.41L16.59 6L10.59 12L16.59 18Z"
              fill={fill}
            />
            <path
              d="M11.59 18L13 16.59L8.42 12L13 7.41L11.59 6L5.59 12L11.59 18Z"
              fill={fill}
            />
          </>
        )
      case 'right':
      default:
        return (
          <>
            <path
              d="M7.41 6L6 7.41L10.58 12L6 16.59L7.41 18L13.41 12L7.41 6Z"
              fill={fill}
            />
            <path
              d="M12.41 6L11 7.41L15.58 12L11 16.59L12.41 18L18.41 12L12.41 6Z"
              fill={fill}
            />
          </>
        )
    }
  },
  { viewBox: '0 0 24 24', width: '24px', height: '24px' },
)
